//
// Location Dropdown Widget
//
// Handle dropdown display and location selection
//

module.exports = class LocationDropdownWidget {
  constructor($host, config) {
    this.activeClass = 'is-active';

    // Dom

    this.dom = {
      main: $host,
      window: $(window),
      close: $('[data-location-dropdown-close]', $host),
      trigger: $('[data-location-dropdown-trigger]', $host),
      location: $('[data-location-dropdown-location]:not(.is-active)', $host),
      form: $('[data-location-dropdown-form]', $host),
      locality: $('[data-location-dropdown-locality]', $host),
      csrfToken: $('input', $host)
    };

    // Listeners

    this.dom.close.on('click', this.close.bind(this));
    this.dom.trigger.on('click', this.open.bind(this));
    this.dom.window.on('mouseup', this.pageClick.bind(this));

    if (config.mode !== 'shopify') {
      this.dom.location.on('click', this.locationClick.bind(this));
    }
  }

  // Events

  close() {
    this.dom.main.removeClass(this.activeClass);
  }

  open() {
    this.dom.main.addClass(this.activeClass);
  }

  locationClick(e) {
    this.dom.locality.prop('value', e.currentTarget.dataset.locationDropdownLocation);
    this.dom.form.submit();
  }

  pageClick(e) {
    if ($(e.target).closest(this.dom.main).length === 0) {
      this.close();
    }
  }
};
